let startPromise = null;

export function prepareApp() {
  if (!MOCK_API) {
    return Promise.resolve();
  }

  if (startPromise) {
    return startPromise;
  }

  startPromise = (async () => {
    const { worker } = await import('./browser.js');

    await worker.start({
      serviceWorker: {
        // Copied into `assets/` via `npx msw init assets --save`.
        // We serve it at `/mockServiceWorker.js` in webpack-dev-server so the
        // browser allows a `/` scope (needed to intercept `/api/*`).
        url: '/mockServiceWorker.js',
        options: {
          scope: '/',
        },
      },
      onUnhandledRequest: (request, print) => {
        const url = new URL(request.url);
        if (!url.pathname.startsWith('/api/')) {
          return;
        }
        if (MOCK_API_STRICT) {
          print.error();
          return;
        }
        print.warn();
      },
    });
  })();

  return startPromise;
}
